// extracted by mini-css-extract-plugin
export default {"container":"ListPlaceholderSeries_container__Z4D1y","textLine":"ListPlaceholderSeries_textLine__7vSs1","imgArrow":"ListPlaceholderSeries_imgArrow__mHose"};